var AddressSuggestion = (function(settings) {
    var url = 'api/shop/myaccount/v1/accounts/' + settings.SiteAccountID + '/my-account/addresses/suggested';

    var Address = function(address) {

        var findLine = function(line) {
            return _.find(address, function(a) {
                return _.isEqual(_.sortBy(a.types), _.sortBy(line));
            });
        }

        return {
            get: function() {
                var result = [];
                var line = '';
                if (arguments.length > 0) {
                    for (var i = 0; i < arguments.length; i++) {
                        line = findLine(arguments[i]);
                        line && result.push(line.short_name);
                    }
                }
                
                return result.join(' ');
            }
        }
    }

    var getAddressLine = function(_address) {
        var subpremise = _address.get(["subpremise"]);
        var street_number = _address.get(["street_number"]);
        var route = _address.get(['route']);

        if (subpremise && street_number && route) {
            return subpremise + '/' + street_number + ' ' + route;
        }

        if (street_number && route) {
            return street_number + ' ' + route;
        }

        return route || '';
    }

    var mapAddress = function(data) {
        if (window.app && app.event && app.event.addressSuggestionSelect) {
            app.event.addressSuggestionSelect();
        }

        var _address = new Address(data.result.address_components);
        switch (GlobalSettings.Iso) {
        case 'au':
            return {
                AddressLines: getAddressLine(_address),
                Suburb: _address.get(['locality', 'political']),
                State: _address.get(['administrative_area_level_1', 'political']),
                Postcode: _address.get(['postal_code'])
            }
        case 'nz':
            return {
                AddressLines: getAddressLine(_address),
                Suburb: _address.get(["political", "sublocality", "sublocality_level_1"]),
                Postcode: _address.get(['postal_code']),
                City: _address.get(["locality", "political"])
            }
        case 'sg':
            return {
                AddressLines: getAddressLine(_address),
                Postcode: _address.get(['postal_code'])
            }
        case 'my':
            return {
                AddressLines: getAddressLine(_address),
                Suburb: _address.get(["political", "sublocality", "sublocality_level_1"]),
                State: _address.get(["locality", "political"]),
                City: _address.get(["administrative_area_level_1", "political"]),
                Postcode: _address.get(['postal_code'])
            }
        case 'hk':
            return {
                AddressLines: getAddressLine(_address),
                Suburb: _address.get(["neighborhood", "political"]),
                State: _address.get(["administrative_area_level_1", "political"])
            }
        default:
        }
    };

    return {
        getSuggestion: function(search) {
            return $.getJSON(url + '?search=' + encodeURIComponent(search))
                .then(function(list) {
                    if (window.app && app.event && app.event.addressSuggestionShow) {
                        app.event.addressSuggestionShow();
                    }
                    return list;
                });
        },
        getAddress: function(address) {
            return $.getJSON(url + '?address=' + encodeURIComponent(address))
                .then(mapAddress);
        }
    }
});